module.exports = __webpack_public_path__ + "media/PAG82-01.afb707bc.mp3";